export const purpurFilterBlurOnImage = "blur(24px)";
